import {
    trackerFactoryBase,
    ModuleTrackingFunction,
} from '@fandom/tracking-metrics/tracking/'
import { TrackData } from '@fandom/tracking-metrics/tracking/dataLayer'

export enum EVENT_CATEGORIES {
    PLAYBACK = 'playback',
    AD = 'ad',
    CONTENT = 'content',
}

export interface PlayerDetails {
    id: string
    provider: string
    version: string
}

export interface VideoTracker {
    trackPlayerEligible(playerElementId: string): void
    trackPlayerLoad(playerElementId: string): void
    trackPlayerError(playerElementId: string, errorType: string): void
    trackPlayerReady(playerElementId: string): void
    track(trackingData: TrackData): void
}

function createVideoTracker(tracker: ModuleTrackingFunction): VideoTracker {
    return {
        trackPlayerEligible(playerElementId: string) {
            tracker({
                player_element_id: playerElementId,
                event_name: 'video_player_eligible',
            })
        },
        trackPlayerLoad(playerElementId: string) {
            tracker({
                player_element_id: playerElementId,
                event_name: 'video_player_load',
            })
        },
        trackPlayerError(playerElementId, errorType) {
            tracker({
                player_element_id: playerElementId,
                event_name: 'video_player_error',
                video_player_error_code: errorType,
            })
        },
        trackPlayerReady(playerElementId) {
            tracker({
                player_element_id: playerElementId,
                event_name: 'video_player_ready',
            })
        },
        track(trackingData: TrackData) {
            tracker(trackingData)
        },
    }
}

export function initTracker(
    player: PlayerDetails,
    category: string = EVENT_CATEGORIES.PLAYBACK,
): VideoTracker {
    const baseTrackParams: TrackData = {
        category: category,
        event: 'video-player-event',
        video_player: player.provider,
        video_player_id: player.id,
        video_player_version: player.version,
        sendToDW: true,
        dwPath: '__track/special/video',
    }

    return createVideoTracker(trackerFactoryBase(baseTrackParams))
}
